<template>
  <div class="content mb-0 pb-0">
    <div class="container-fluid" style="overflow-y: auto; max-height: calc(100vh - 100px); border: 1px solid #ddd; padding: 0;">
      <table class="table table-bordered table-striped table-sm">
        <tr>
          <th>Persoon</th>
          <th>Actie</th>
          <th style="max-width: 60%">Data</th>
          <th>Wanneer</th>
        </tr>
        <tr v-for="audit in auditList">
          <td>{{audit.user}}</td>
          <td>{{audit.action}}</td>
          <td>
            <pre @click="expandPayload=audit.id" :class="{'closed': expandPayload !== audit.id, 'open': expandPayload === audit.id}">{{audit.payload}}
            </pre>
          </td>
          <td>{{audit.date | moment('from')}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
  import axios from "axios";

  export default {
    components: {
    },
    data () {
      return {
        auditList: [],
        expandPayload: '',
      }
    },

    methods: {
      getAuditList() {
        var self = this
        axios.get("/api/audit")
          .then((response) => {
            self.auditList = response.data
          })
          .catch((errors) => {
            console.log("Cannot get Audit List")
            console.log(errors)
          })
      },
    },
    mounted() {
      this.getAuditList()
    }
  }

</script>
<style>
  .closed {
    margin-bottom: 0;
    max-height: 20px;
    overflow-y: hidden;
  }
  .closed:hover {
    background-color: #efefef;
    cursor: pointer;
  }
  .open {
    max-height: 1000px;
    overflow-y: auto;
  }
</style>
